export default __webpack_public_path__ + "static/media/space.7d0863ff.png";